<ion-header>
  <ion-toolbar>
    <ion-item lines="none" slot="start" class="open-barierr__logo-container">
      <ion-icon
        class="open-barierr__logo"
        src="../assets/images/app-logo.svg"
      ></ion-icon>
    </ion-item>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="content-card-noborder open-barierr__mobile-container">
    <ion-card-header class="open-barierr__mobile-header">
      <ion-card-title>
        Firma: STI
        <!-- {{ row.company.name }} -->
      </ion-card-title>
      <ion-card-subtitle>
        <ng-container>
          <!-- *ngIf="row.user" -->
          Gość: Jan Kowalski
        </ng-container>
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content class="open-barierr__mobile-content">
      <ion-grid class="no-padding-grid booking-mobile">
        <ion-row>
          <ion-col class="display-flex ion-justify-content-end">
            <!-- <ng-container *ngFor="let item of barriers"> -->
            <!-- (click)="
            !showBarrierButtonForPastBookings
              ? onShowPopover($event)
              : openBarrier(item.key)
          " -->
            <ion-button
              [ngClass]="{
                disabled: !showBarrierButtonForPastBookings
              }"
              class="open-barierr__mobile-open-button"
              [fill]="showBarrierButtonForPastBookings ? 'solid' : 'outline'"
            >
              <ion-icon
                slot="start"
                name="push-outline"
                [color]="
                  showBarrierButtonForPastBookings ? 'primary' : 'secondary'
                "
              ></ion-icon>
              {{ "SPACE.BARRIER" | translate }}
              <ion-icon
                *ngIf="!showBarrierButtonForPastBookings"
                src="../../../assets/icons/info.svg"
                class="margin-left-8"
              ></ion-icon>
            </ion-button>
            <!-- </ng-container> -->
            <ion-button
              Fill="outline"
              class="open-barierr__mobile-generate-qr-button"
              [ngClass]="{
                'open-barierr__mobile-generate-qr-button--disabled': !showBarrierButtonForPastBookings
              }"
              [disabled]="!showBarrierButtonForPastBookings"
            >
              <!-- *ngIf="row.qrcode" -->
              <!-- (click)="onQRCodePreview($event, row.qrcode.qrcodeValue)" -->
              <ion-icon
                [ngClass]="{
                  'open-barierr__mobile-open-button--disabled': showBarrierButtonForPastBookings
                }"
                slot="icon-only"
                color="secondary"
                src="../../../assets/icons/qr-code.svg"
              ></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="open-barierr__mobile-details-container">
            <div class="open-barierr__mobile-details-inner-container">
              <span>
                <ion-icon class="margin-right-8" name="Business"></ion-icon>
                Budynek: Business Park III
              </span>
            </div>
            <div class="open-barierr__mobile-details-inner-container">
              <span>
                <ion-icon
                  class="margin-right-8"
                  name="layers-outline"
                ></ion-icon>
                Poziom: -2
              </span>
            </div>
            <div class="open-barierr__mobile-details-inner-container">
              <span>
                <ion-icon
                  src="../../../assets/icons/car.svg"
                  class="margin-right-8"
                ></ion-icon>
                Mijesce parkingowe: 12
              </span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            class="open-barierr__mobile-details-container open-barierr__mobile-details-container--user-owner"
          >
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="open-barierr__mobile-dates-label">
            <span>
              {{ "SPACE.RESERVATION_START" | translate }}
            </span>
            <span>
              {{ "SPACE.RESERVATION_END" | translate }}
            </span>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col
            class="display-flex ion-align-items-center ion-justify-content-between"
          >
            <div
              class="open-barierr__mobile-dot open-barierr__mobile-dot--start"
            ></div>
            <div class="open-barierr__mobile-separator"></div>
            <div
              class="open-barierr__mobile-dot open-barierr__mobile-dot--end"
            ></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="open-barierr__mobile-dates-container">
            <span>
              12.12.2020 12:00
              <!-- {{ row.startTime | date: "HH:mm dd MMM yyyy":"":currentLang }} -->
            </span>
            <span>
              12.12.2020 14:00
              <!-- {{ row.endTime | date: "HH:mm dd MMM yyyy":"":currentLang }} -->
            </span>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>
</ion-content>
